// Verkenning en project: twee soorten werkruimte. De UI zegt "Verkenning" en
// "Project"; "werkruimte" is alleen de verzamelnaam.

export type WorkspaceKind = "exploration" | "project";
export type KindFilter = "all" | WorkspaceKind;

interface HasKind {
  id: number;
  kind?: WorkspaceKind;
}

export const KIND_LABEL: Record<WorkspaceKind, string> = {
  exploration: "Verkenning",
  project: "Project",
};

// Een verkenning is lichtblauw, een project groen: in het label, de kop van de
// werkruimte en op de kaart (layerStyles.ts).
export const KIND_BADGE: Record<WorkspaceKind, string> = {
  exploration: "bg-sky-100 text-sky-800",
  project: "bg-green/15 text-dark-green",
};

export const kindOf = (workspace?: { kind?: WorkspaceKind } | null): WorkspaceKind =>
  workspace?.kind ?? "project";

export const KIND_FILTERS: { value: KindFilter; label: string }[] = [
  { value: "all", label: "Alles" },
  { value: "exploration", label: "Verkenningen" },
  { value: "project", label: "Projecten" },
];

export const isExploration = (workspace?: { kind?: WorkspaceKind } | null) =>
  workspace?.kind === "exploration";

export const filterByKind = <T extends HasKind>(workspaces: T[], filter: KindFilter): T[] =>
  filter === "all" ? workspaces : workspaces.filter((w) => (w.kind ?? "project") === filter);

// Op de globale kaart: alle projecten, en van de verkenningen alleen de actieve.
// Oude shortlists zouden anders verstoppen waar de echte projecten liggen.
export const workspacesOnMap = <T extends HasKind>(workspaces: T[], activeId: number | null): T[] =>
  workspaces.filter((w) => !isExploration(w) || w.id === activeId);
